<template><div><h1>VUX 源码本地运行</h1>
<div class="tip">
<p>请更新 <code>NodeJS</code> 版本到 <code>v7.6.0</code> 以上，<code>build</code> 命令逐步使用 <code>async</code>。</p>
</div>
<pre class="hljs"><code>yarn // 使用 yarn.lock 保证依赖版本一致
yarn dev
</code></pre>
<h2>本地查看文档</h2>
<pre class="hljs"><code>npm run doc:build // 构建文档
<span class="hljs-built_in">cd</span> docs
yarn
npm run dev // 耗时较长
</code></pre>
<h2>文档相关命令</h2>
<blockquote>
<p>docs 目录下的相关命令，它们是 npm run doc:build 的一部分，但是可以单独运行</p>
</blockquote>
<pre class="hljs"><code>node compile // 生成文档路由
node component-contributions // 从 git 记录里获取每个组件提交历史

npm run doc:dev // 运行
</code></pre>
<h2>构建部分文档</h2>
<p>文档页面比较多等待 build 命令会长，因此可以只构建部分文档方便快速查看。</p>
<pre class="hljs"><code><span class="hljs-built_in">cd</span> docs
node compile --include datetime // 只构建 datetime 相关文档
npm run dev
</code></pre>
</div></template><script>
export default {
  head: {"title":"VUX 源码本地运行 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vux-development-146.vue?224f7cb8